import { Client } from '@notionhq/client';
import notionData from 'shared/fake-notion/databases.json';
import { httpsCallable } from 'shared/services/firebase';
import { ref } from 'vue';

export const NOTION_CLIENT_DIRECT = 'direct';
export const NOTION_CLIENT_PROXY = 'proxy';
export const NOTION_CLIENT_LOCAL = 'local';
export default function useNotionClient(functions) {
  const client = ref({});
  const initClient = (notionToken) => {
    switch (import.meta.env.VITE_NOTION_CLIENT) {
      case NOTION_CLIENT_PROXY: {
        client.value = {
          search: async (query) => {
            try {
              const notionProxy = httpsCallable(functions, 'notionProxy');
              const res = await notionProxy({ notionToken, method: 'search', payload: query });
              return res.data;
            } catch (e) {
              console.log(e);
              return { results: [] };
            }
          },
          blocks: async (query) => {
            const notionProxy = httpsCallable(functions, 'notionProxy');
            const res = await notionProxy({ notionToken, method: 'blocks', payload: query });
            return res.data;
          },
          pages: {
            retrieve: async (query) => {
              const notionProxy = httpsCallable(functions, 'notionProxy');
              const res = await notionProxy({ notionToken, resource: 'pages', method: 'retrieve', payload: query });
              return res.data;
            },
            create: async (payload) => {
              const notionProxy = httpsCallable(functions, 'notionProxy');
              const res = await notionProxy({ notionToken, resource: 'pages', method: 'create', payload });
              return res.data;
            },
          },
          databases: {
            retrieve: async (query) => {
              const notionProxy = httpsCallable(functions, 'notionProxy');
              const res = await notionProxy({ notionToken, resource: 'databases', method: 'retrieve', payload: query });
              return res.data;
            },
          },
          // Where the schema lives since Notion 2025-09-03.
          dataSources: {
            retrieve: async (query) => {
              const notionProxy = httpsCallable(functions, 'notionProxy');
              const res = await notionProxy({ notionToken, resource: 'dataSources', method: 'retrieve', payload: query });
              return res.data;
            },
          },
        };
        break;
      }
      case NOTION_CLIENT_LOCAL: {
        const databases = ref(notionData.results);
        client.value = {
          search: async () => ({ results: databases.value }),
          blocks: () => ({}),
          pages: {
            retrieve: () => new Promise((resolve) => {
              resolve(databases.value[0]);
            }),
            create: () => {

            },
          },
          databases: { retrieve: () => [] },
          dataSources: { retrieve: () => [] },
        };
        break;
      }
      case NOTION_CLIENT_DIRECT: {
        client.value = new Client({ auth: notionToken });
        break;
      }
      default: {
        throw new Error('client type not valid');
      }
    }
  };

  return {
    initClient,
    client,
  };
}
